module.exports = __webpack_public_path__ + "img/portugal-mental-and-behavioural-disorders-male.814a6ea5.png";